function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "et6jogb50a",
  x1: ".537%",
  x2: "57.578%",
  y1: ".504%",
  y2: "73.101%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".04%",
  stopColor: "#4AC9E2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#56FDD2"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.499
}, /*#__PURE__*/React.createElement("g", {
  fill: "url(#et6jogb50a)",
  transform: "translate(0 -113)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.047 413.885C46.205 491.09 205.89 431.12 187.983 268.823 170.077 106.526 90.025 123.82 10.11 123.837c-79.915.018-144.713 64.96-144.73 145.055-.018 80.095 108.51 67.789 144.668 144.993z",
  transform: "rotate(-60 27.379 285.296)"
})));

var SvgIconOvalLeft1 = function SvgIconOvalLeft1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 305,
    viewBox: "0 0 200 305",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOvalLeft1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-oval-left-1.c6ed489b.svg";
export { ForwardRef as ReactComponent };